<script setup>
import { computed, defineEmits, defineProps, onMounted, ref } from "vue";
import Modal from "@/components/Tools/Modal.vue";
import i18n from "@/core/plugins/vue-i18n";
import FormHelper from "@/components/Tools/FormHelper/FormHelper.vue";
import { useCurrentProjectFilter } from "@/composables/useCurrentProjectFilter";
import Queues from "@/components/Settings/Queues/queues";
import workflowManager from "@/components/Workflows/workflowManager";
import { addEventToLoadingQueue } from "@/composables/useLoadingQueue";
import { useStore } from "@/core/services/store";

const emits = defineEmits(["close"]);

const props = defineProps({
  showImportDialog: {
    type: Boolean,
    default: false
  },
  importData: {
    type: [File, Object],
    default: () => {}
  }
});

const formValues = ref({});
const options = ref({});

const form = computed(() => [
  {
    name: "queue_id",
    type: "select",
    label: i18n.t("table.queue"),
    options: options.value
  }
]);

const formConfig = {
  enableVariables: false,
  snippedPrefix: "salesChannelManagementApp"
};

const showDialog = computed({
  get() {
    return props.showImportDialog;
  },
  set(newValue) {
    if (newValue) {
      return;
    }
    emits("close");
  }
});

function importWorkflow() {
  addEventToLoadingQueue({ key: "loadingFile" });

  const store = useStore();

  let data = new FormData();
  data.append("file", props.importData);
  data.append("queue_id", formValues.value?.queue_id);

  let selectedProject = store.getters.selectedProject;

  if (selectedProject?.id) {
    data.append("project_id", selectedProject.id);
  }

  workflowManager
    .import(data)
    .then(() => {
      showDialog.value = false;
    })
    .catch(error => {
      this.$error(error);
    });
}

onMounted(async () => {
  const params = {
    page: 1,
    perPage: 100
  };
  const { filter } = useCurrentProjectFilter();

  await Queues.getAll(params, filter.value)
    .then(response => {
      options.value = response.data.map(q => ({
        value: q.id,
        label: q.raw_name
      }));
    })
    .catch(error => {
      this.$error(error);
    });
});
</script>

<template>
  <Modal
    :show-modal="showDialog"
    :title="$t('workflowDesigner.workflowImportHelp').toString()"
    @toggle-modal="showDialog = $event"
  >
    <template #content>
      <FormHelper v-model="formValues" :config="formConfig" :form="form" />
    </template>
    <template #footer>
      <button
        class="btn btn-primary w-25 text-center float-end"
        @click="importWorkflow"
        @keyup.enter="importWorkflow"
      >
        {{ $t("assignments.import") }}
      </button>
    </template>
  </Modal>
</template>
